import { Link } from "react-router-dom";
import type { MediaItem } from "@/lib/types";
import { typeLabel } from "@/lib/catalog";

interface HotRankingProps {
  items: MediaItem[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-extrabold text-foreground-950">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-600">
            <i className="ri-fire-line text-base"></i>
          </span>
          热门榜单
        </h2>
        <span className="text-xs text-foreground-400">按热度排行</span>
      </div>
      <ul className="flex flex-col gap-1">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-extrabold ${
                  i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <span className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 海报`}
                  title={`${item.title} - 金桔影院`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate font-heading text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span>{typeLabel(item.type)}</span>
                  <span className="flex items-center gap-0.5 text-primary-600">
                    <i className="ri-star-fill text-[11px]"></i>
                    {item.rating.toFixed(1)}
                  </span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}